/**
 * Format an ISO date string as an absolute, human-readable date
 * (e.g. "August 5, 2026") — used for hover tooltips over relative-time
 * displays like "9 minutes ago". Returns null for missing/unparsable input.
 */
export const formatAbsoluteDate = (isoString) => {
  if (!isoString) return null;
  const parsed = new Date(isoString);
  if (isNaN(parsed.getTime())) return null;
  return parsed.toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });
};
